import { useTranslation } from 'react-i18next';

export const REPLAY_LAYERS = [
  { key: 'stop',      labelKey: 'replayLayers.stops',      defaultOn: true },
  { key: 'overspeed', labelKey: 'replayLayers.overspeed',  defaultOn: true },
  { key: 'alert',     labelKey: 'replayLayers.alerts',     defaultOn: true },
  { key: 'geofence',  labelKey: 'replayLayers.geofence',   defaultOn: true },
  { key: 'poi',       labelKey: 'replayLayers.poi',        defaultOn: true },
  { key: 'harsh',     labelKey: 'replayLayers.harsh',      defaultOn: false },
];

const FALLBACK = {
  stops: 'Stops', overspeed: 'Overspeed', alerts: 'Alerts',
  geofence: 'Crossings', poi: 'POI visits', harsh: 'Harsh',
};

export default function ReplayLayerFilters({ enabled, onToggle }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap gap-1.5">
      {REPLAY_LAYERS.map((l) => {
        const on = enabled[l.key];
        const fb = FALLBACK[l.labelKey.split('.')[1]] || l.key;
        return (
          <button
            key={l.key}
            type="button"
            onClick={() => onToggle(l.key)}
            className={`px-2 py-0.5 rounded-full text-[10px] font-semibold transition-colors ${
              on ? 'bg-blue-600 text-white' : 'bg-slate-200/70 text-slate-500 dark:bg-slate-700/70 dark:text-slate-400'
            }`}
          >
            {t(l.labelKey, fb)}
          </button>
        );
      })}
    </div>
  );
}
